import { IViewDetail } from '../types/IView';
import { WebClientApiResult } from '../WebClientApiResponse';
import { VizPortalClientMethod } from '../VizPortalClientMethod';

export interface IGetViewByPathParams {
  path: string;
}

// The ViewDetail should be a property of the result, not the type of the result object itself.
export interface IGetViewByPathResult extends WebClientApiResult, IViewDetail {
}

export const GetViewByPathMethod = new VizPortalClientMethod<IGetViewByPathParams, IGetViewByPathResult>('getViewByPath');
